export const scheduleHasEmployee = (schedule, employeeId) => {
  if (employeeId == null) return false;
  return schedule?.employee_ids?.some((id) => String(id) === String(employeeId)) || false;
};

export const filterScheduleEvents = (events, sessions, employeeId, customerId) => {
  let filteredEvents = events;

  if (employeeId != null) {
    filteredEvents = filteredEvents.filter((event) => scheduleHasEmployee(event.schedule, employeeId));
  }

  if (customerId != null) {
    const scheduleIds = new Set(
      sessions
        .filter((session) => String(session.customer_id) === String(customerId))
        .map((session) => String(session.schedule_id))
    );
    filteredEvents = filteredEvents.filter((event) =>
      scheduleIds.has(String(event.schedule?.schedule_id))
    );
  }

  return filteredEvents;
};
